import { render, staticRenderFns } from "./SupplierRequestsPage.vue?vue&type=template&id=4ea8884c&scoped=true&lang=pug&"
import script from "./SupplierRequestsPage.vue?vue&type=script&lang=js&"
export * from "./SupplierRequestsPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierRequestsPage.vue?vue&type=style&index=0&id=4ea8884c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea8884c",
  null
  
)

export default component.exports